// Copy for the translated homepage and Among Us IRL page. Machine-drafted: a native speaker
// should read each language before it is promoted. The name "Sus Party" is never translated.
// Spanish is neutral (ustedes, teléfono). Romanian and Portuguese avoid "sus" in the copy.

const fr = {
    hreflang: 'fr',
    nav: { play: 'Jouer', irl: 'Among Us en vrai' },
    footerNote: "Sus Party est un jeu de soirée indépendant. Il n'est ni affilié à Innersloth ni à Among Us, ni approuvé par eux.",
    common: {
        eyebrow: 'Sus Party · Jeu gratuit dans le navigateur',
        start: 'Lancer une partie',
        generator: 'Créer une liste de tâches',
        note: 'Gratuit · Sans compte ni téléchargement · De 3 à 20+ joueurs',
        faqTitle: 'Questions fréquentes',
        readyTitle: 'Prêts à jouer ?',
        readyText: 'Ouvrez Sus Party, créez une salle et partagez le code. La partie démarre en deux minutes.',
    },
    home: {
        title: 'Sus Party : jeu de soirée gratuit sur téléphone, façon Among Us',
        description: "Un jeu de soirée gratuit inspiré d'Among Us et du Loup-Garou. Chacun joue sur son téléphone en se déplaçant dans la maison. De 3 à 20+ joueurs, sans appli.",
        h1: 'Le jeu de soirée façon Among Us, en vrai',
        lead: "Sus Party ressemble beaucoup à Among Us en vrai ou au Loup-Garou. C'est très simple à jouer et idéal pour les soirées entre amis. Chaque joueur reçoit un rôle secret sur son téléphone, fait de vraies tâches dans la maison et essaie de démasquer les intrus.",
        stepsTitle: 'Comment ça marche',
        steps: [
            ['Créez la partie', "Un hôte ouvre susparty.com et crée une salle. Les autres rejoignent avec le code à quatre lettres."],
            ['Recevez votre rôle', "La plupart des joueurs font partie de l'équipage. Un ou plusieurs intrus se cachent parmi eux."],
            ['Faites vos tâches, trouvez les intrus', "L'équipage se déplace dans la maison pour faire ses tâches. Les intrus éliminent en secret. N'importe qui peut lancer une réunion pour voter."],
        ],
        irlLink: 'Comment jouer à Among Us en vrai →',
        faqs: [
            ['Faut-il télécharger une appli ?', "Non. Tout se joue dans le navigateur du téléphone. Il faut juste une connexion internet."],
            ['Combien de joueurs faut-il ?', "De 3 à 20+. Pour une première partie, 5 à 8 joueurs avec un intrus, c'est parfait."],
            ["C'est gratuit ?", 'Oui, sans publicité et sans compte.'],
        ],
    },
    irl: {
        title: 'Among Us en vrai : jouer à la maison avec vos téléphones | Sus Party',
        description: 'Jouez à Among Us en vrai, gratuitement. Les téléphones distribuent les rôles secrets, les tâches, les réunions et les votes pour 3 à 20+ joueurs. Sans appli.',
        h1: 'Jouer à Among Us en vrai avec Sus Party',
        lead: "Votre maison devient la carte et vos amis deviennent les suspects. Sus Party s'occupe des rôles, des tâches et des votes sur chaque téléphone. Vous vous occupez du reste.",
        rolesTitle: 'Les rôles',
        roles: [
            ['Équipage', 'Faites de vraies tâches dans la maison et votez pour éliminer les intrus.'],
            ['Intrus', "Faites semblant de travailler, éliminez l'équipage en secret et ne vous faites pas prendre."],
        ],
        setupTitle: 'Préparer la partie',
        steps: [
            ['Choisissez les pièces', 'Utilisez les pièces communes et un point de réunion. Laissez les pièces privées hors du jeu.'],
            ['Préparez les tâches', "Prenez la liste d'exemple ou créez une liste adaptée à votre maison avec le générateur."],
            ['Partagez le code', "Chacun rejoint avec le code de la salle. L'hôte lance la partie et les rôles sont distribués."],
        ],
        winTitle: 'Qui gagne ?',
        win: "L'équipage gagne en votant contre tous les intrus. Quand l'équipage a fini ses tâches, les intrus sont révélés et une réunion commence. Les intrus gagnent s'ils éliminent tout l'équipage.",
        faqs: [
            ['Faut-il une appli ?', 'Non. Chacun ouvre susparty.com dans le navigateur de son téléphone et rejoint avec le code de la salle.'],
            ['Combien de joueurs ?', "De 3 à 20+. Il faut au moins deux membres d'équipage par intrus."],
            ['Sus Party est-il un jeu officiel Among Us ?', "Non. Sus Party est un jeu indépendant, sans lien avec Innersloth."],
        ],
    },
};

const es = {
    hreflang: 'es',
    nav: { play: 'Jugar', irl: 'Among Us en la vida real' },
    footerNote: 'Sus Party es un juego de fiesta independiente. No está afiliado, respaldado ni patrocinado por Innersloth ni por Among Us.',
    common: {
        eyebrow: 'Sus Party · Juego gratis en el navegador',
        start: 'Empezar una partida',
        generator: 'Crear una lista de tareas',
        note: 'Gratis · Sin cuenta ni descargas · De 3 a 20+ jugadores',
        faqTitle: 'Preguntas frecuentes',
        readyTitle: '¿Listos para jugar?',
        readyText: 'Abre Sus Party, crea una sala y comparte el código. La partida empieza en dos minutos.',
    },
    home: {
        title: 'Sus Party: juego de fiesta gratis en el teléfono, estilo Among Us',
        description: 'Un juego de fiesta gratis inspirado en Among Us y Mafia. Cada quien juega en su teléfono mientras recorre la casa. De 3 a 20+ jugadores, sin descargar nada.',
        h1: 'El juego de fiesta estilo Among Us, en la vida real',
        lead: 'Sus Party se parece mucho a Among Us en la vida real o a Mafia. Es muy fácil de jugar e ideal para fiestas y reuniones. Cada jugador recibe un rol secreto en su teléfono, hace tareas reales por la casa e intenta descubrir a los intrusos.',
        stepsTitle: 'Cómo funciona',
        steps: [
            ['Crea la partida', 'Un anfitrión abre susparty.com y crea una sala. Los demás entran con el código de cuatro letras.'],
            ['Recibe tu rol', 'La mayoría es parte de la tripulación. Uno o más intrusos se esconden entre ellos.'],
            ['Haz tareas y encuentra a los intrusos', 'La tripulación recorre la casa haciendo tareas. Los intrusos eliminan en secreto. Cualquiera puede convocar una reunión para votar.'],
        ],
        irlLink: 'Cómo jugar Among Us en la vida real →',
        faqs: [
            ['¿Hay que descargar una app?', 'No. Todo funciona en el navegador del teléfono. Solo se necesita internet.'],
            ['¿Cuántos jugadores se necesitan?', 'De 3 a 20+. Para la primera partida, de 5 a 8 jugadores con un intruso funciona muy bien.'],
            ['¿Es gratis?', 'Sí, sin anuncios y sin cuenta.'],
        ],
    },
    irl: {
        title: 'Among Us en la vida real: juega en casa con el teléfono | Sus Party',
        description: 'Juega Among Us en la vida real gratis. Los teléfonos reparten roles secretos, tareas, reuniones y votos para 3 a 20+ jugadores. Sin descargar nada.',
        h1: 'Juega Among Us en la vida real con Sus Party',
        lead: 'Tu casa se convierte en el mapa y tus amigos en los sospechosos. Sus Party se encarga de los roles, las tareas y los votos en cada teléfono. Ustedes ponen el resto.',
        rolesTitle: 'Los roles',
        roles: [
            ['Tripulación', 'Hace tareas reales por la casa y vota para expulsar a los intrusos.'],
            ['Intrusos', 'Fingen hacer tareas, eliminan a la tripulación en secreto y tratan de que no los descubran.'],
        ],
        setupTitle: 'Prepara la partida',
        steps: [
            ['Elige los espacios', 'Usa las áreas comunes y un punto de reunión. Deja fuera las habitaciones privadas.'],
            ['Prepara las tareas', 'Usa la lista de ejemplo o crea una a la medida de tu casa con el generador.'],
            ['Comparte el código', 'Todos entran con el código de la sala. El anfitrión empieza la partida y se reparten los roles.'],
        ],
        winTitle: '¿Quién gana?',
        win: 'La tripulación gana si expulsa a todos los intrusos. Cuando termina sus tareas, los intrusos quedan al descubierto y empieza una reunión. Los intrusos ganan si eliminan a toda la tripulación.',
        faqs: [
            ['¿Se necesita una app?', 'No. Cada quien abre susparty.com en el navegador del teléfono y entra con el código de la sala.'],
            ['¿Cuántos jugadores?', 'De 3 a 20+. Se necesitan al menos dos tripulantes por cada intruso.'],
            ['¿Sus Party es un juego oficial de Among Us?', 'No. Sus Party es un juego independiente, sin relación con Innersloth.'],
        ],
    },
};

const de = {
    hreflang: 'de',
    nav: { play: 'Spielen', irl: 'Among Us im echten Leben' },
    footerNote: 'Sus Party ist ein unabhängiges Partyspiel. Es steht in keiner Verbindung zu Innersloth oder Among Us und wird von ihnen weder unterstützt noch gesponsert.',
    common: {
        eyebrow: 'Sus Party · Kostenloses Browserspiel',
        start: 'Spiel starten',
        generator: 'Aufgabenliste erstellen',
        note: 'Kostenlos · Ohne Konto und Download · 3 bis 20+ Spieler',
        faqTitle: 'Häufige Fragen',
        readyTitle: 'Bereit zum Spielen?',
        readyText: 'Öffnet Sus Party, erstellt einen Raum und teilt den Code. In zwei Minuten geht es los.',
    },
    home: {
        title: 'Sus Party: Kostenloses Partyspiel fürs Handy, wie Among Us',
        description: 'Ein kostenloses Partyspiel, angelehnt an Among Us und Werwolf. Alle spielen auf dem Handy und laufen dabei durchs Haus. Für 3 bis 20+ Spieler, ohne App.',
        h1: 'Das Partyspiel wie Among Us, im echten Leben',
        lead: 'Sus Party ist sehr ähnlich wie Among Us im echten Leben oder Werwolf. Es ist ganz einfach zu spielen und ideal für Partys vor Ort. Alle bekommen eine geheime Rolle aufs Handy, erledigen echte Aufgaben im Haus und versuchen, die Eindringlinge zu entlarven.',
        stepsTitle: "So funktioniert's",
        steps: [
            ['Spiel erstellen', 'Ein Host öffnet susparty.com und erstellt einen Raum. Alle anderen treten mit dem Code aus vier Buchstaben bei.'],
            ['Rolle erhalten', 'Die meisten gehören zur Crew. Ein oder mehrere Eindringlinge verstecken sich unter ihnen.'],
            ['Aufgaben erledigen, Eindringlinge finden', 'Die Crew läuft durchs Haus und erledigt Aufgaben. Die Eindringlinge schalten heimlich Leute aus. Alle können ein Meeting einberufen und abstimmen lassen.'],
        ],
        irlLink: 'So spielt ihr Among Us im echten Leben →',
        faqs: [
            ['Brauchen wir eine App?', 'Nein. Alles läuft im Handy-Browser. Ihr braucht nur Internet.'],
            ['Wie viele Spieler braucht man?', '3 bis 20+. Für die erste Runde passen 5 bis 8 Spieler mit einem Eindringling gut.'],
            ['Ist es kostenlos?', 'Ja, ohne Werbung und ohne Konto.'],
        ],
    },
    irl: {
        title: 'Among Us im echten Leben: zu Hause mit dem Handy spielen | Sus Party',
        description: 'Spielt Among Us im echten Leben, kostenlos. Die Handys verteilen geheime Rollen, Aufgaben, Meetings und Abstimmungen für 3 bis 20+ Spieler. Ohne App.',
        h1: 'Among Us im echten Leben spielen mit Sus Party',
        lead: 'Euer Zuhause wird zur Karte, eure Freunde werden zu Verdächtigen. Sus Party kümmert sich auf jedem Handy um Rollen, Aufgaben und Abstimmungen. Den Rest macht ihr.',
        rolesTitle: 'Die Rollen',
        roles: [
            ['Crew', 'Erledigt echte Aufgaben im Haus und stimmt ab, um die Eindringlinge rauszuwerfen.'],
            ['Eindringlinge', 'Tun so, als würden sie arbeiten, schalten heimlich Crewmitglieder aus und lassen sich nicht erwischen.'],
        ],
        setupTitle: 'Spiel vorbereiten',
        steps: [
            ['Räume auswählen', 'Nutzt die gemeinsamen Räume und einen Treffpunkt für Meetings. Private Zimmer bleiben außen vor.'],
            ['Aufgaben vorbereiten', 'Nehmt die Beispielliste oder erstellt mit dem Generator eine Liste für euer Zuhause.'],
            ['Code teilen', 'Alle treten mit dem Raumcode bei. Der Host startet das Spiel und die Rollen werden verteilt.'],
        ],
        winTitle: 'Wer gewinnt?',
        win: 'Die Crew gewinnt, wenn sie alle Eindringlinge rauswählt. Sind alle Aufgaben erledigt, werden die Eindringlinge aufgedeckt und ein Meeting beginnt. Die Eindringlinge gewinnen, wenn sie die ganze Crew ausschalten.',
        faqs: [
            ['Braucht man eine App?', 'Nein. Alle öffnen susparty.com im Handy-Browser und treten mit dem Raumcode bei.'],
            ['Wie viele Spieler?', '3 bis 20+. Pro Eindringling braucht es mindestens zwei Crewmitglieder.'],
            ['Ist Sus Party ein offizielles Among-Us-Spiel?', 'Nein. Sus Party ist ein unabhängiges Spiel und hat nichts mit Innersloth zu tun.'],
        ],
    },
};

const ro = {
    hreflang: 'ro',
    nav: { play: 'Joacă', irl: 'Among Us în viața reală' },
    footerNote: 'Sus Party este un joc de petrecere independent. Nu este afiliat, susținut sau sponsorizat de Innersloth sau Among Us.',
    common: {
        eyebrow: 'Sus Party · Joc gratuit în browser',
        start: 'Începe un joc',
        generator: 'Creează o listă de sarcini',
        note: 'Gratuit · Fără cont sau descărcare · Între 3 și 20+ jucători',
        faqTitle: 'Întrebări frecvente',
        readyTitle: 'Gata de joc?',
        readyText: 'Deschide Sus Party, creează o cameră și trimite codul. Jocul începe în două minute.',
    },
    home: {
        title: 'Sus Party: joc de petrecere gratuit pe telefon, ca Among Us',
        description: 'Un joc de petrecere gratuit, inspirat din Among Us și Mafia. Fiecare joacă pe telefon și se plimbă prin casă. Între 3 și 20+ jucători, fără aplicație.',
        h1: 'Jocul de petrecere ca Among Us, în viața reală',
        lead: 'Sus Party seamănă mult cu Among Us în viața reală sau cu Mafia. Este foarte ușor de jucat și ideal pentru petreceri cu prietenii. Fiecare jucător primește un rol secret pe telefon, face sarcini reale prin casă și încearcă să-i descopere pe intruși.',
        stepsTitle: 'Cum funcționează',
        steps: [
            ['Creează jocul', 'O gazdă deschide susparty.com și creează o cameră. Ceilalți intră cu codul din patru litere.'],
            ['Primește-ți rolul', 'Cei mai mulți fac parte din echipaj. Unul sau mai mulți intruși se ascund printre ei.'],
            ['Fă sarcini, găsește intrușii', 'Echipajul se plimbă prin casă și face sarcini. Intrușii elimină pe ascuns. Oricine poate convoca o ședință pentru vot.'],
        ],
        irlLink: 'Cum se joacă Among Us în viața reală →',
        faqs: [
            ['Trebuie să descărcăm o aplicație?', 'Nu. Totul merge în browserul telefonului. Aveți nevoie doar de internet.'],
            ['Câți jucători sunt necesari?', 'Între 3 și 20+. Pentru primul joc, 5–8 jucători cu un intrus merg foarte bine.'],
            ['Este gratuit?', 'Da, fără reclame și fără cont.'],
        ],
    },
    irl: {
        title: 'Among Us în viața reală: joacă acasă pe telefon | Sus Party',
        description: 'Joacă Among Us în viața reală, gratuit. Telefoanele împart roluri secrete, sarcini, ședințe și voturi pentru 3 până la 20+ jucători. Fără aplicație.',
        h1: 'Joacă Among Us în viața reală cu Sus Party',
        lead: 'Casa ta devine harta, iar prietenii tăi devin suspecții. Sus Party se ocupă de roluri, sarcini și voturi pe fiecare telefon. Restul e treaba voastră.',
        rolesTitle: 'Rolurile',
        roles: [
            ['Echipaj', 'Face sarcini reale prin casă și votează ca să-i elimine pe intruși.'],
            ['Intruși', 'Se prefac că lucrează, elimină echipajul pe ascuns și încearcă să nu fie prinși.'],
        ],
        setupTitle: 'Pregătește jocul',
        steps: [
            ['Alege spațiile', 'Folosește camerele comune și un loc pentru ședințe. Lasă camerele private în afara jocului.'],
            ['Pregătește sarcinile', 'Folosește lista de exemplu sau creează una potrivită pentru casa ta cu generatorul.'],
            ['Trimite codul', 'Toți intră cu codul camerei. Gazda pornește jocul și rolurile sunt împărțite.'],
        ],
        winTitle: 'Cine câștigă?',
        win: 'Echipajul câștigă dacă îi elimină prin vot pe toți intrușii. Când echipajul termină sarcinile, intrușii sunt dezvăluiți și începe o ședință. Intrușii câștigă dacă elimină tot echipajul.',
        faqs: [
            ['E nevoie de o aplicație?', 'Nu. Fiecare deschide susparty.com în browserul telefonului și intră cu codul camerei.'],
            ['Câți jucători?', 'Între 3 și 20+. Pentru fiecare intrus e nevoie de cel puțin doi membri ai echipajului.'],
            ['Este Sus Party un joc oficial Among Us?', 'Nu. Sus Party este un joc independent, fără legătură cu Innersloth.'],
        ],
    },
};

const pt = {
    hreflang: 'pt-BR',
    nav: { play: 'Jogar', irl: 'Among Us na vida real' },
    footerNote: 'Sus Party é um jogo de festa independente. Não é afiliado, endossado nem patrocinado pela Innersloth ou por Among Us.',
    common: {
        eyebrow: 'Sus Party · Jogo grátis no navegador',
        start: 'Começar um jogo',
        generator: 'Criar uma lista de tarefas',
        note: 'Grátis · Sem conta nem download · De 3 a 20+ jogadores',
        faqTitle: 'Perguntas frequentes',
        readyTitle: 'Prontos para jogar?',
        readyText: 'Abra o Sus Party, crie uma sala e compartilhe o código. O jogo começa em dois minutos.',
    },
    home: {
        title: 'Sus Party: jogo de festa grátis no celular, estilo Among Us',
        description: 'Um jogo de festa grátis inspirado em Among Us e Cidade Dorme. Cada um joga no celular enquanto anda pela casa. De 3 a 20+ jogadores, sem baixar app.',
        h1: 'O jogo de festa estilo Among Us, na vida real',
        lead: 'Sus Party é muito parecido com Among Us na vida real ou com Cidade Dorme. É muito fácil de jogar e ideal para festas e encontros. Cada jogador recebe um papel secreto no celular, faz tarefas de verdade pela casa e tenta descobrir os intrusos.',
        stepsTitle: 'Como funciona',
        steps: [
            ['Crie o jogo', 'Um anfitrião abre susparty.com e cria uma sala. Os outros entram com o código de quatro letras.'],
            ['Receba seu papel', 'A maioria faz parte da tripulação. Um ou mais intrusos se escondem entre eles.'],
            ['Faça tarefas e encontre os intrusos', 'A tripulação anda pela casa fazendo tarefas. Os intrusos eliminam em segredo. Qualquer pessoa pode chamar uma reunião para votar.'],
        ],
        irlLink: 'Como jogar Among Us na vida real →',
        faqs: [
            ['Precisa baixar algum app?', 'Não. Tudo funciona no navegador do celular. Só precisa de internet.'],
            ['Quantos jogadores precisa?', 'De 3 a 20+. Para o primeiro jogo, 5 a 8 jogadores com um intruso funciona muito bem.'],
            ['É grátis?', 'Sim, sem anúncios e sem conta.'],
        ],
    },
    irl: {
        title: 'Among Us na vida real: jogue em casa pelo celular | Sus Party',
        description: 'Jogue Among Us na vida real de graça. Os celulares distribuem papéis secretos, tarefas, reuniões e votos para 3 a 20+ jogadores. Sem baixar app.',
        h1: 'Jogue Among Us na vida real com o Sus Party',
        lead: 'Sua casa vira o mapa e seus amigos viram os suspeitos. O Sus Party cuida dos papéis, das tarefas e dos votos em cada celular. Vocês cuidam do resto.',
        rolesTitle: 'Os papéis',
        roles: [
            ['Tripulação', 'Faz tarefas de verdade pela casa e vota para expulsar os intrusos.'],
            ['Intrusos', 'Fingem fazer tarefas, eliminam a tripulação em segredo e tentam não ser pegos.'],
        ],
        setupTitle: 'Prepare o jogo',
        steps: [
            ['Escolha os cômodos', 'Use os espaços comuns e um ponto de reunião. Deixe os quartos privados fora do jogo.'],
            ['Prepare as tarefas', 'Use a lista de exemplo ou crie uma do jeito da sua casa com o gerador.'],
            ['Compartilhe o código', 'Todos entram com o código da sala. O anfitrião começa o jogo e os papéis são distribuídos.'],
        ],
        winTitle: 'Quem vence?',
        win: 'A tripulação vence se expulsar todos os intrusos. Quando ela termina as tarefas, os intrusos são revelados e começa uma reunião. Os intrusos vencem se eliminarem toda a tripulação.',
        faqs: [
            ['Precisa de app?', 'Não. Cada um abre susparty.com no navegador do celular e entra com o código da sala.'],
            ['Quantos jogadores?', 'De 3 a 20+. É preciso pelo menos dois tripulantes para cada intruso.'],
            ['Sus Party é um jogo oficial de Among Us?', 'Não. Sus Party é um jogo independente, sem ligação com a Innersloth.'],
        ],
    },
};

export const TRANSLATED_CONTENT = { fr, es, de, ro, pt };
